export const books = [
  {
    title: "The Giving Tree",
    subtitle: "",
    authors: ["Shel Silverstein"],
    description: `"Once there was a tree...and she loved a little boy."

    So begins a story of unforgettable perception, beautifully written and illustrated by the gifted and versatile Shel Silverstein.
    
    Every day the boy would come to the tree to eat her apples, swing from her branches, or slide down her trunk...and the tree was happy. But as the boy grew older he began to want more from the tree, and the tree gave and gave and gave.`,
    released: `1964-01-01`,
    language: "English",
    length: 64,
    medium: "eBook",
    genres: ["Childrens", "Classics", "Poetry"],
    read: [{ start: `2023-01-06`, end: `2023-01-06` }],
    rating: 3,
    review: "",
    impressions: [""],
    honour: null,
    cover: `the-giving-tree.jpg`,
  },
  {
    title: "Heartstopper",
    subtitle: "Volume One",
    authors: ["Alice Oseman"],
    description:
      "Charlie, a highly-strung, openly gay over-thinker, and Nick, a cheerful, soft-hearted rugby player, meet at a British all-boys grammar school. Friendship blooms quickly, but could there be something more...? Charlie Spring is in Year 10 at Truham Grammar School for Boys. The past year hasn't been too great, but at least he's not being bullied anymore. Nick Nelson is in Year 11 and on the school rugby team. He's heard a little about Charlie - the kid who was outed last year and bullied for a few months - but he's never had the opportunity to talk to him.",
    released: `2018-10-01`,
    language: "English",
    length: 288,
    medium: "eBook",
    genres: [
      "Fiction",
      "Graphic Novels",
      "Romance",
      "LGBTQ",
      "Young Adult",
      "Contemporary",
    ],
    read: [{ start: `2023-01-07`, end: `2023-01-10` }],
    rating: 4,
    review: "",
    impressions: ["Cute"],
    honour: null,
    cover: `hearstopper-volume-one.jpg`,
  },
  {
    title: "Forgiveness Parade",
    subtitle: "",
    authors: ["Jeffrey McDaniel"],
    description:
      "In Jeffrey McDaniel's second book, it is hard to separate the humor from the pain. Both qualities are omnipresent whether he's tackling dysfunctional family memories in 'The Most Awful Lullaby', or broken-hearted romance in poems like 'Another Long Day in the Office of Dreams'.",
    released: `1998-10-01`,
    language: "English",
    length: 80,
    medium: "eBook",
    genres: ["Poetry"],
    read: [{ start: `2023-01-06`, end: `2023-01-14` }],
    rating: 5,
    review: "",
    impressions: ["Loved"],
    honour: null,
    cover: `forgiveness-parade.jpg`,
  },
  {
    title: "Cetatea cucului din nori",
    subtitle: "",
    authors: ["Anthony Doerr"],
    description:
      "Constantinopol, 1453 – de-o parte și de alta a zidurilor orașului, doi copii, Anna și Omeir, sunt sortiți să se întâlnească, pentru a salva o carte și, prin gestul lor, pe ei înșiși. Idaho, în prezent – la etajul bibliotecii publice, octogenarul Zeno împreună cu cinci copii montează o bizară piesă de teatru, în vreme ce, la parter, adolescentul idealist Seymour se pregătește să detoneze o bombă, crezând că luptă pentru o cauză nobilă. În spațiu, peste câteva decenii – Konstance, pe o navă interstelară având ca destinație o exoplanetă, supraviețuiește doar călăuzită de o poveste pe care i-o spunea tatăl ei seară de seară. Destinele tuturor personajelor sunt legate de misteriosul manuscris din vechime, care celebrează puterea scrisului și a imaginației.",
    released: `2021-09-28`,
    language: "Romanian",
    length: 524,
    medium: "Paperback",
    genres: [
      "Fiction",
      "Historical Fiction",
      "Science Fiction",
      "Literary Fiction",
    ],
    read: [{ start: `2022-12-28`, end: `2023-01-17` }],
    rating: 5,
    review: `Past: Constantinople. Anna takes care of her ailing sister, her only family, inside the walls of Constantinople. On the other side of the walls Omeir, taken from his home and family, is taking part in the city's siege.

    Present: Idaho. Old Zeno along with five children rehearse a play in the public library. In the same building, on a different floor, adolescent Seymour plants a bomb for what he thinks is a noble cause.
    
    Future: The spaceship Argos. Fourteen years old Konstance counts the days she has spent locked by herself in a room.
    
    And what brings together time and space and people is a book. A manuscript of a long-forgotten story. The tale of a hero who perseveres through whatever may come.
    
    Cloud Cuckoo Land is a testament to the power of books and stories — one of humanity’s greatest inventions. Stories that shape us, help us grow, and give us hope to go forward. I’m in awe thinking of the intimate relationship between humanity and stories, thinking of how mere ideas and ideals helped build civilizations and individuals.
    
    And thinking about how fiction often proves truer than reality.
    
    This novel has been a journey and I enjoyed every step of it. The characters are all very likable and will make you root for them.
    And there is something about historical fiction that took a hold of me; the parts of the story set around the siege of Constantinople were the most enjoyable for me.
    
    Though at times the story is tragic it holds onto hope until the end and has an optimistic outlook. I shed some tears while reading it but that might be just me. Humans do have that effect on me. And more than history and war, more than the world we live in and the stories we tell about it, this is what this novel has been about — humanity. And I absolutely loved it.
    
    It has been some time since I took a book off the shelf and in a few sentences, it convinced me to take it home and I am glad I did.`,
    impressions: ["Loved"],
    honour: ["yf"],
    cover: `cloud-cuckoo-land.jpg`,
  },
  {
    title: "The Prophet",
    subtitle: "",
    authors: ["Kahlil Gibran"],
    description: ` In this inspirational, allegorical guide, Al Mustafa the prophet delivers spiritual yet practical homilies on the work of beauty, truth, possessions, sorrow, joy, death and more. Translated into more than fifty languages and among the best-selling books of all time, The Prophet remains a wise and revitalising handbook for the soul.`,
    released: `1923-01-01`,
    language: "English",
    length: 128,
    medium: "Hardcover",
    genres: ["Poetry", "Classics", "Philosophy", "Spirituality", "Religion"],
    read: [{ start: `2023-01-21`, end: `2023-02-02` }],
    rating: 5,
    review: ``,
    impressions: [`Loved`],
    honour: ``,
    cover: `the-prophet.jpg`,
  },
  {
    title: "The Complete Stories",
    subtitle: "",
    authors: ["Flannery O'Connor"],
    description: `The publication of this extraordinary volume firmly established Flannery O'Connor's monumental contribution to American fiction. There are thirty-one stories here in all, including twelve that do not appear in the only two story collections O'Connor put together in her short lifetime - Everything That Rises Must Converge and A Good Man Is Hard to Find.`,
    released: `1971-11-08`,
    language: "English",
    length: 555,
    medium: "Paperback",
    genres: [
      "Fiction",
      "Short Stories",
      "Classics",
      "Gothic",
      "Southern Gothic",
    ],
    read: [{ start: `2022-08-18`, end: `2023-02-03` }],
    rating: 5,
    review: `I’m conflicted when writing about a book I really like because, on one hand, I could talk for hours about it, and on the other, I feel like my words won’t do justice so I refrain myself. I don’t know where this will go but I decided to give it a chance.

    I am well aware of my subjectivity when praising this anthology but, then again, this is how we perceive Life.
    
    One of my favourite subjects in literature (and beyond it) is people and human experiences. It is a real joy to catch glimpses of humans being humans -- the little things that we may try to hide, but that make us who we are. Being a silent observer of a show where I’m no longer the main character. And this has been one of the gifts of Flannery O’Connor’s prose: glimpses into the lives of people; strange people, gray people, mostly misfits (my favorite type), from an author with an uncanny grasp of the nuances of human behaviour. O’Connor doesn’t miss anything; the characters she writes are far from perfect, morally flawed, but real. They are you and me (though maybe a bit more), a mixed bag of good and bad, of quirks, longings, obsessions. Sometimes while reading these stories, one will have a hard time telling apart the victim from the villain. As a cartoonist also, she wrote her characters as she would draw them. The descriptions jump out of the page in the form of caricatures.
    
    Set in the South (of the United States) the stories are written in the genre of Southern Gothic, a genre that I came to love. A sardonic sense of humour, which I adored, is sewn into these stories that are as funny as they are thought-provoking or straight-up weird.
    
    As a devout Catholic, Flannery O’Connor wrote from a perspective of faith, touching on subjects of morality. Her stories address subjects such as racial integration, the Holocaust, and intersexuality. Issues of race come up often in her stories as do people with disabilities (as she herself was). Recurring motifs of farms, widowed women, sons with inclinations to be writers, and birds let one into the author's mind.
    
    She wrote the most catchy and beautiful openings to her stories and the most surprising, allegorical, and often violent endings. The characters and situations she wrote about are the most creative, nonconforming, and weird ones I have encountered in my readings.
    There’s an elegance and beauty about O'Connor's writing. The sentences are a pleasure to read: picking words like flower petals she had carefully laid down a path.
    
    The depth of these stories and their dense meaning is something I will explore for the years to come. They are the type of stories that don't give out everything on the first reading so you can be sure that at the second or third reading (or the hundredth) you will still find something surprising about them.
    
    There is no measure of how much I love these stories or of the impression they left on me. I only know that I encountered something great. Flannery O'Connor's The Complete Stories is everything I love about stories and literature.`,
    impressions: [`Loved`],
    honour: ["atf"],
    cover: `the-complete-stories.jpg`,
  },
  {
    title: "Giovanni's Room",
    subtitle: "",
    authors: ["James Baldwin"],
    description: `In the 1950s Paris of American expatriates, liaisons, and violence, a young man finds himself caught between desire and conventional morality. With a sharp, probing imagination, James Baldwin's now-classic narrative delves into the mystery of loving and creates a moving, highly controversial story of death and passion that reveals the unspoken complexities of the human heart.`,
    released: `1956-01-01`,
    language: "English",
    length: 178,
    medium: "eBook",
    genres: ["Fiction", "Classics", "LGBTQ", "Romance"],
    read: [{ start: `2023-02-03`, end: `2023-02-07` }],
    rating: 4,
    review: ``,
    impressions: [``],
    honour: ``,
    cover: `giovanni-s-room.jpg`,
  },
  {
    title: "The Fire Next Time",
    subtitle: "",
    authors: ["James Baldwin"],
    description: `
    At once a powerful evocation of James Baldwin's early life in Harlem and a disturbing examination of the consequences of racial injustice, the book is an intensely personal and provocative document from the iconic author of If Beale Street Could Talk and Go Tell It on the Mountain. It consists of two "letters," written on the occasion of the centennial of the Emancipation Proclamation, that exhort Americans, both black and white, to attack the terrible legacy of racism. Described by The New York Times Book Review as "sermon, ultimatum, confession, deposition, testament, and chronicle...all presented in searing, brilliant prose," The Fire Next Time stands as a classic of literature.`,
    released: `1963-01-31`,
    language: "English",
    length: 130,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Essays",
      "Classics",
      "Race",
      "History",
      "Politics",
      "Social Justice",
    ],
    read: [{ start: `2023-02-07`, end: `2023-02-10` }],
    rating: 5,
    review: ``,
    impressions: [``],
    honour: ``,
    cover: `the-fire-next-time.jpg`,
  },
  {
    title: "Ereticii Dunei",
    subtitle: "Dune #5",
    authors: ["Frank Herbert"],
    description: `Împăratul-Zeu al Dunei e mort de secole, iar imperiul este o ruină. Odată pornită pe Poteca de Aur proiectată de Leto, omenirea și-a început exodul – milioane de oameni s-au împrăștiat prin tot universul cunoscut. Arakis, numită acum Rakis, a redevenit un uriaș deșert, însă viermii de nisip sunt pe moarte.

    Unii oameni doresc să se întoarcă și se formează noi facțiuni care vor putere și influență asupra rămășițelor imperiului. Însă, în nisipurile de pe Rakis, o fată pe nume Sheeana readuce la viață miturile fremenilor care călăreau viermii de nisip și umple de fervoare religioasă întreaga galaxie. Căci pare întruparea eroinei din profeția Împăratului-Zeu.`,
    released: `1984-04-01`,
    language: "Romanian",
    length: 608,
    medium: "Paperback",
    genres: ["Fiction", "Science Fiction", "Classics"],
    read: [{ start: `2022-01-01`, end: `2023-02-18` }],
    rating: 5,
    review: `I enjoyed this one. The world-building is exceptional as ever and it managed to bring me back into the Dune Universe after the previous God Emperor of Dune`,
    impressions: [`Liked`],
    honour: ``,
    cover: `ereticii-dunei.jpg`,
  },
  {
    title: "A Psalm for the Wild-Built",
    subtitle: "Monk and Robot #1",
    authors: ["Becky Chambers"],
    description: `Centuries before, robots of Panga gained self-awareness, laid down their tools, wandered, en masse into the wilderness, never to be seen again. They faded into myth and urban legend.

    Now the life of the tea monk who tells this story is upended by the arrival of a robot, there to honor the old promise of checking in. The robot cannot go back until the question of "what do people need?" is answered. But the answer to that question depends on who you ask, and how. They will need to ask it a lot. Chambers' series asks: in a world where people have what they want, does having more matter?`,
    released: `2021-07-13`,
    language: "English",
    length: 160,
    medium: "eBook",
    genres: ["Fiction", "Science Fiction", "Fantasy", "Novella"],
    read: [{ start: `2023-02-19`, end: `2023-02-22` }],
    rating: 3,
    review: ``,
    impressions: [`Disliked`],
    honour: ``,
    cover: `a-psalm-for-the-wild-built.jpg`,
  },
  {
    title: "Night Sky with Exit Wounds",
    subtitle: "",
    authors: ["Ocean Vuong"],
    description: `Ocean Vuong's first full-length collection aims straight for the perennial "big"—and very human—subjects of romance, family, memory, grief, war, and melancholia. None of these he allows to overwhelm his spirit or his poems, which demonstrate, through breath and cadence and unrepentant enthrallment, that a gentle palm on a chest can calm the fiercest hungers.`,
    released: `2016-04-05`,
    language: "English",
    length: 89,
    medium: "eBook",
    genres: ["Poetry", "LGBTQ", "Contemporary"],
    read: [{ start: `2023-02-16`, end: `2023-02-25` }],
    rating: 4,
    review: ``,
    impressions: [`Loved`],
    honour: ``,
    cover: `night-sky-with-exit-wounds.jpg`,
  },
  {
    title: "At Night All Blood is Black",
    subtitle: "",
    authors: ["David Diop"],
    description: `Selected by students across France to win the Prix Goncourt des Lycéens, David Diop’s English-language, historical fiction debut At Night All Blood is Black is a “powerful, hypnotic, and dark novel” (Livres Hebdo) of terror and transformation in the trenches of the First World War.`,
    released: `2018-08-16`,
    language: "English",
    length: 145,
    medium: "eBook",
    genres: ["Fiction", "Historical Fiction", "War"],
    read: [{ start: `2023-02-22`, end: `2023-02-25` }],
    rating: 5,
    review: ``,
    impressions: [`Liked`],
    honour: ["yf"],
    cover: `at-night-all-blood-is-black.jpg`,
  },
  {
    title: "Flatland",
    subtitle: "A Romance of Many Dimensions",
    authors: ["Edwin A. Abbott"],
    description: `Flatland by Edwin A. Abbot is a curious work of science and mathematical fiction. In the novel, the narrator named A. Square is a mathematician and resident of the two-dimensional Flatland. In Flatland, women are thin, straight lines (the lowliest of shapes), and men may have any number of sides, depending on their social status.`,
    released: `1884-01-01`,
    language: "English",
    length: 89,
    medium: "eBook",
    genres: ["Fiction", "Classics", "Philosophy", "Mathematics"],
    read: [{ start: `2023-02-27`, end: `2023-03-01` }],
    rating: 5,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `flatland.jpg`,
  },
  {
    title: "Frog and Toad Are Friends",
    subtitle: "Frog and Toad #1",
    authors: ["Arnold Lobel"],
    description: `From writing letters to going swimming, telling stories to finding lost buttons, Frog and Toad are always there for each other—just as best friends should be. Frog and Toad Are Friends is a Level Two I Can Read book, geared for kids who read on their own but still need a little help.`,
    released: `1970-08-26`,
    language: "English",
    length: 64,
    medium: "eBook",
    genres: ["Fiction", "Childrens", "Picture Books", "Classics", "Fantasy"],
    read: [{ start: `2023-03-04`, end: `2023-03-05` }],
    rating: 4,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `frog-and-toad-are-friends.jpg`,
  },
  {
    title: "Readings from the Book of Exile",
    subtitle: "",
    authors: ["Pádraig Ó Tuama"],
    description: `One of the most intriguing and engaging voices in contemporary Christianity is that of the Irish poet, Padraig O Tuama and this is his first, long-awaited poetry collection. Hailing from the Ikon community in Belfast and working closely with its founder, the bestselling writer Pete Rollins, Padraig's poetry interweaves parable, poetry, art, activism and philosophy into an original and striking expression of faith. Padraig's poems are accessible, memorable profound and challenging. They emerge powerfully from a context of struggle and conflict and yet are filled with hope. Full Text - Short`,
    released: `2012-07-01`,
    language: "English",
    length: 96,
    medium: "eBook",
    genres: ["Poetry", "Spirituality", "Theology", "LGBTQ"],
    read: [{ start: `2023-02-27`, end: `2023-03-08` }],
    rating: 4,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `readings-from-the-book-of-exile.jpg`,
  },
  {
    title: "The Song of Achilles",
    subtitle: "",
    authors: ["Madeline Miller"],
    description: `Achilles, “best of all the Greeks,” is everything Patroclus is not—strong, beautiful, the child of a goddess—and by all rights their paths should never cross. Yet one day, Achilles takes the shamed prince under his wing and soon their tentative connection gives way to a steadfast friendship. As they grow into young men skilled in the arts of war and medicine, their bond blossoms into something far deeper—despite the displeasure of Achilles’ mother Thetis, a cruel sea goddess with a hatred of mortals.`,
    released: `2011-09-20`,
    language: "English",
    length: 352,
    medium: "Paperback",
    genres: [
      "Fiction",
      "Fantasy",
      "Historical Fiction",
      "Mythology",
      "Romance",
      "LGBTQ",
    ],
    read: [{ start: `2023-03-06`, end: `2023-03-16` }],
    rating: 4,
    review: ``,
    impressions: [`Loved`],
    honour: ``,
    cover: `the-song-of-achilles.jpg`,
  },
  {
    title: "Of Mice and Men",
    subtitle: "",
    authors: ["John Steinbeck"],
    description: `They are an unlikely pair: George is "small and quick dark of face"; Lennie, a man of tremendous size, has the mind of a young child. Yet they have formed a "family," clinging together in the face of loneliness and alienation.

    Laborers in California's dusty vegetable fields, they hustle work when they can, living a hand-to-mouth existence. For George and Lennie have a plan: to own an acre of land and a shack they can call their own. When they land jobs on a ranch in the Salinas Valley, the fulfillment of their dream seems to be within their grasp. But even George cannot guard Lennie from the provocations of a flirtatious woman, nor predict the consequences of Lennie's unswerving obedience to the things George taught him.`,
    released: `1937-02-25`,
    language: "English",
    length: 107,
    medium: "eBook",
    genres: ["Fiction", "Classics", "Historical Fiction"],
    read: [{ start: `2023-03-16`, end: `2023-03-23` }],
    rating: 5,
    review: ``,
    impressions: [`Loved`],
    honour: ``,
    cover: `of-mice-and-men.jpg`,
  },
  {
    title: "My Life Had Stood a Loaded Gun",
    subtitle: "",
    authors: ["Emily Dickinson"],
    description: ``,
    released: `1880-01-01`,
    language: "English",
    length: 52,
    medium: "Paperback",
    genres: ["Poetry", "Classics", "Feminism"],
    read: [{ start: `2023-03-24`, end: `2023-04-04` }],
    rating: 3,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `my-life-has-stood-a-loaded-gun.jpg`,
  },
  {
    title: "Povestiri bizare",
    subtitle: "",
    authors: ["Olga Tokarczuk"],
    description: ` În zece texte dense, pline de dinamism şi surprinzătoare de la premise pînă la final, imaginaţia neîngrădită ce caracterizează Povestirile bizare ale Olgăi Tokarczuk cucereşte nu doar prin subiecte ori prin atmosfera creată, ci şi prin forţa empatică ce le străbate. Pendulînd între fantastic, SF, straniu şi insolit, aceste povestiri reprezintă tot atîtea mostre de virtuozitate şi inventivitate artistică ale acestei remarcabile prozatoare.
    `,
    released: `2023-01-01`,
    language: "Romanian",
    length: 253,
    medium: "Paperback",
    genres: [
      "Fiction",
      "Short Stories",
      "Magical  Realism",
      "Polish Literature",
      "Contemporary",
    ],
    read: [{ start: `2023-03-26`, end: `2023-04-07` }],
    rating: 3,
    review: `Maybe I’ve set my expectations wrong.

    That is not to say that this was a bad book or a poorly written one, but most of the time the stories didn’t do it for me. I found the ideas the stories are built upon intriguing, but I personally felt that they weren’t exploited to their real potential. The stories started with a good premise that got lost in a fog on the way.
    
    The last stories (which were also the longest) are the ones that I enjoyed the most and the ones that felt complete and had a satisfactory ending.
    
    
    As an end note, I couldn’t but wonder how some of these stories would have looked like in a Ted Chiang book.`,
    impressions: [`Disappointed`],
    honour: ``,
    cover: `povestiri-bizare.jpg`,
  },
  {
    title: "Când nu mai înțelegem lumea",
    subtitle: "",
    authors: ["Benjamín Labatut"],
    description: `
    Când nu mai înțelegem lumea este o meditație asupra legăturilor complicate dintre descoperirile din lumea fizicii și a matematicii și tendința umanității de a se autodistruge. Un melanj de investigație biografică și imaginație ce amintește în mod șocant de stilul lui W.G. Sebald, cartea lui Labatut plonjează în viața unor personalități reale, precum Fritz Haber, Alexander Grothendieck, Werner Heisenberg, Erwin Schrödinger, ale căror descoperiri geniale fie au influențat definitiv viața în bine, fie au dat naștere, fără intenția autorilor, unor suferințe inimaginabile.`,
    released: `2019-01-01`,
    language: "Romanian",
    length: 208,
    medium: "Paperback",
    genres: [
      "Non-Fiction",
      "Short Stories",
      "Science",
      "History",
      "Philosophy",
      "Essays",
    ],
    read: [{ start: `2023-04-08`, end: `2023-04-10` }],
    rating: 5,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `cand-nu-mai-intelegem-lumea.jpg`,
  },
  {
    title: "Maurice",
    subtitle: "",
    authors: ["E.M. Forster"],
    description: `Scris la începutul secolului trecut, imediat după Howards End, şi publicat abia în 1971, Maurice a mers înaintea timpului său prin temă şi prin ideea că dragostea dintre doi bărbaţi poate exista.`,
    released: `1971-01-01`,
    language: "Romanian",
    length: 264,
    medium: "eBook",
    genres: ["Fiction", "Classics", "Romance", "LGBTQ", "Historical Fiction"],
    read: [{ start: `2023-04-11`, end: `2023-04-20` }],
    rating: 5,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `maurice.jpg`,
  },
  {
    title: "Poartă-ți plugul peste oasele morților",
    subtitle: "",
    authors: ["Olga Tokarczuk"],
    description: ` Cel de-al șaptelea roman al Olgăi Tokarczuk este unic în creația scriitoarei, întrucît narațiunea îmbracă forma unui thriller etic, întrețesut cu elemente metafizice, nelipsite din concepția despre viață și lume a scriitoarei, în care evenimentele escaladează și conduc spre un final neașteptat, surprinzător. Într-un sat de munte izolat, unde iarna rămîn doar trei case locuite, asistăm la o serie de crime misterioase în centrul cărora par să fie animalele și Janina Duszejko, o profesoară de engleză pensionară, excentrică, militantă pentru drepturile animalelor, pasionată de astrologie și de misticismul lui William Blake.
    `,
    released: `2009-11-25`,
    language: "Romanian",
    length: 279,
    medium: "Paperback",
    genres: [
      "Fiction",
      "Mystery",
      "Literary Fiction",
      "Polish Literature",
      "Crime",
      "Contemporary",
    ],
    read: [{ start: `2023-04-21`, end: `2023-05-03` }],
    rating: 3,
    review: ``,
    impressions: [`Disappointed`],
    honour: ``,
    cover: `poarta-ti-plugul-peste-oasele-mortilor.jpg`,
  },
  {
    title: "The Endarkenment",
    subtitle: "",
    authors: ["Jeffrey McDaniel"],
    description: `Known for his commanding stage presence as a reader, McDaniel trades hard in his fourth book on his rough-and-tumble persona--a recovering addict from the working class streets--while also showing softer sides. McDaniel's sometimes awkward, if earnest searching might just be what allows him to find moments of great beauty, humor and stillness. --Publishers Weekly`,
    released: `2008-01-01`,
    language: "English",
    length: 524,
    medium: "eBook",
    genres: ["Poetry"],
    read: [{ start: `2023-04-22`, end: `2023-05-09` }],
    rating: 3,
    review: `I love Jeffrey McDaniel's witty style and use of language. It makes for some great poems.

    (I liked The Endarkenment, but I loved Forgiveness Parade)
    `,
    impressions: [`Liked`],
    honour: ``,
    cover: `the-endarkenment.jpg`,
  },
  {
    title: "Songs of Innocence and of Experience",
    subtitle: "",
    authors: ["William Blake"],
    description: `
    Songs of Innocence and Experience is one of the best-loved poetry collections of all time, an innovative and groundbreaking experiment in which Blake intertwined text and image to dazzling effect. The volume, published sometimes as two separate collections, juxtaposes the innocent world of childhood with the corrupt and repressed one of adults. `,
    released: `1794-01-01`,
    language: "English",
    length: 102,
    medium: "Hardcover",
    genres: ["Poetry", "Classics", "Romanticism"],
    read: [{ start: `2023-05-18`, end: `2023-06-18` }],
    rating: 4,
    review: ``,
    impressions: [``],
    honour: ``,
    cover: `songs-of-innocence-and-of-experience.jpg`,
  },
  {
    title: "Heartstopper",
    subtitle: "Volume Two",
    authors: ["Alice Oseman"],
    description: `Nick and Charlie are best friends. Nick knows Charlie's gay, and Charlie is sure that Nick isn't.

    But love works in surprising ways, and Nick is discovering all kinds of things about his friends, his family ... and himself.`,
    released: `2019-07-11`,
    language: "English",
    length: 320,
    medium: "eBook",
    genres: ["Fiction", "Graphic Novels", "Romance", "LGBTQ", "Contemporary"],
    read: [{ start: `2023-06-10`, end: `2023-06-10` }],
    rating: 4,
    review: ``,
    impressions: [`Cute`],
    honour: ``,
    cover: `heartstopper-volume-two.jpg`,
  },
  {
    title: "Capitalist Realism",
    subtitle: "Is There No Alternative?",
    authors: ["Mark Fisher"],
    description: `After 1989, capitalism has presented itself as the only realistic political-economic system. What effects has this “capitalist realism” had on work, culture, education and mental health? Is it possible to imagine an alternative to capitalism that is not some throwback to discredited models of state control?`,
    released: `2009-11-27`,
    language: "English",
    length: 81,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Politics",
      "Philosophy",
      "Economics",
      "Theory",
      "Sociology",
      "Essays",
    ],
    read: [{ start: `2023-06-21`, end: `2023-06-27` }],
    rating: 0,
    review: ``,
    impressions: [`mindblowing`],
    honour: ``,
    cover: `capitalist-realism.jpg`,
  },
  {
    title: "Swimming in the Dark",
    subtitle: "",
    authors: ["Tomasz Jedrowski"],
    description: `Set in early 1980s Poland against the violent decline of communism, a tender and passionate story of first love between two young men who eventually find themselves on opposite sides of the political divide—a stunningly poetic and heartrending literary debut for fans of Andre Aciman, Garth Greenwell, and Alan Hollinghurst.`,
    released: `2020-02-06`,
    language: "English",
    length: 191,
    medium: "eBook",
    genres: ["Fiction", "Historical Fiction", "LGBTQ", "Romance"],
    read: [{ start: `2023-06-22`, end: `2023-06-29` }],
    rating: 4,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `swimming-in-the-dark.jpg`,
  },
  {
    title: "Wise Blood",
    subtitle: "",
    authors: ["Flannery O'Connor"],
    description: `Wise Blood, Flannery O'Connor's astonishing and haunting first novel, is a classic of twentieth-century literature. It is the story of Hazel Motes, a twenty-two-year-old caught in an unending struggle against his inborn, desperate fate. He falls under the spell of a "blind" street preacher named Asa Hawks and his degenerate fifteen-year-old daughter, Sabbath Lily. In an ironic, malicious gesture of his own non-faith, and to prove himself a greater cynic than Hawks, Motes founds the Church Without Christ, but is still thwarted in his efforts to lose God. He meets Enoch Emery, a young man with "wise blood," who leads him to a mummified holy child and whose crazy maneuvers are a manifestation of Motes's existential struggles.`,
    released: `1952-05-15`,
    language: "English",
    length: 248,
    medium: "eBook",
    genres: ["Fiction", "Classics", "Gothic", "Southern Gothic"],
    read: [{ start: `2023-07-01`, end: `2023-07-19` }],
    rating: 5,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `wise-blood.jpg`,
  },
  {
    title: "The New Age of Empire",
    subtitle: "How Racism and Colonialism Still Rule the World",
    authors: ["Kehinde Andrews"],
    description: `The New Age of Empire takes us back to the beginning of the European Empires, outlining the deliberate terror and suffering wrought during every stage of the expansion, and destroys the self-congratulatory myth that the West was founded on the three great revolutions of science, industry and politics. Instead, , slavery and colonialism are the key foundation stones upon which the West was built, and we are still living under this system America is now at the helm, perpetuating global inequality through business, government, and institutions.`,
    released: `2021-02-04`,
    language: "English",
    length: 273,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "History",
      "Politics",
      "Race",
      "Economics",
      "Social Justice",
    ],
    read: [{ start: `2023-07-03`, end: `2023-08-13` }],
    rating: 0,
    review: ``,
    impressions: [`mindblowing`],
    honour: ["yf"],
    cover: `the-new-age-of-empire.jpg`,
  },
  {
    title: "Profit Over People",
    subtitle: "Neoliberalism and Global Order",
    authors: ["Noam Chomsky", "Robert W. McChesney"],
    description: `In Profit Over People, Noam Chomsky takes on neoliberalism: the pro-corporate system of economic and political policies presently waging a form of class war worldwide. By examining the contradictions between the democratic and market principles proclaimed by those in power and those actually practiced, Chomsky critiques the tyranny of the few that restricts the public arena and enacts policies that vastly increase private wealth, often with complete disregard for social and ecological consequences. Combining detailed historical examples and uncompromising criticism, Chomsky offers a profound sense of hope that social activism can reclaim people's rights as citizens rather than as consumers, redefining democracy as a global movement, not a global market.`,
    released: `1998-07-01`,
    language: "English",
    length: 175,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Politics",
      "Economics",
      "Philosophy",
      "History",
      "Sociology",
    ],
    read: [{ start: `2023-07-19`, end: `2023-07-24` }],
    rating: 4,
    review: ``,
    impressions: [`mindblowing`],
    honour: ``,
    cover: `profit-over-people.jpg`,
  },
  {
    title: "Oameni anxioși",
    subtitle: "",
    authors: ["Fredrik Backman"],
    description: `Un spărgător de bănci înarmat fuge de la locul faptei și ajunge într-un apartament scos la vânzare, unde are loc o vizionare. Pentru că poliția e pe urmele sale, se baricadează înăuntru și îi ia ostatici pe cei șapte potențiali cumpărători, aparent normali și inofensivi, printre care doi "rechini" imobiliari, un cuplu de lesbiene, o multimilionară cu tendințe suicidare și un sabotor de vizionări deghizat în iepure. Dar lucrurile o iau razna atunci când ostaticii și spărgătorul încep să-și dezvăluie dramele personale și anxietățile. Când spărgătorul le dă drumul ostaticilor și oamenii legii năvălesc înăuntru, nici urmă de infractor, iar depozițiile halucinante ale martorilor nu fac decât să-i bulverseze și mai mult pe polițiști: Unde e infractorul și ce nu-i în regulă cu oamenii ăștia?`,
    released: `2019-04-25`,
    language: "Romanian",
    length: 464,
    medium: "Paperback",
    genres: ["Fiction", "Contemporary", "Mystery", "Humour"],
    read: [{ start: `2023-07-27`, end: `2023-08-10` }],
    rating: 5,
    review: `I have been, for a few years now, resisting reading Fredrik Backman, on account of his writing not being my style. (I judged the book by its cover. I should have known better)

    Now that I have read this book I can only say that I loved it. I have yet to be sold on the style, but that doesn’t even matter. I love the story, the characters, the mind that conceived it all and every “idiot” that this book is about.
    
    Fredrick Backman is, above all, a story teller. I couldn’t help but wonder how it would be like siting next to him around a campfire or at a dinner table.
    
    Like every book about people, this book made me cry and not just a few times. The last chapters made me want to bury my face in a pillow. (Maybe I should have waited to finish it alone in my bedroom and not on a train)
    
    I don’t plan on reading any other books by Fredrick Backman, but I somehow know this is not the last one.`,
    impressions: [`Liked`],
    honour: ``,
    cover: `oameni-anxiosi.jpg`,
  },
  {
    title: "The Will to Change",
    subtitle: "Men, Masculinity, and Love",
    authors: ["bell hooks"],
    description: `In The Will to Change, bell hooks gets to the heart of the matter and shows men how to express the emotions that are a fundamental part of who they are—whatever their age, marital status, ethnicity, or sexual orientation. But toxic masculinity punishes those fundamental emotions, and it’s so deeply ingrained in our society that it’s hard for men to not comply—but hooks wants to help change that.`,
    released: `2003-12-30`,
    language: "English",
    length: 208,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Feminism",
      "Gender",
      "Psychology",
      "Sociology",
      "Philosophy",
    ],
    read: [{ start: `2023-08-18`, end: `2023-09-20` }],
    rating: 4,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `the-will-to-change.jpg`,
  },

  {
    title: "The Principles of Communism",
    subtitle: "",
    authors: ["Friedrich Engels"],
    description: ``,
    released: `1847-10-01`,
    language: "English",
    length: 50,
    medium: "eBook",
    genres: ["Non-Fiction", "Politics", "Theory", "Economics", "Philosophy"],
    read: [{ start: `2023-10-05`, end: `2023-10-07` }],
    rating: 0,
    review: ``,
    impressions: [`insightful`],
    honour: ``,
    cover: `the-principles-of-communism.jpg`,
  },
  {
    title: "Gaza in Crisis",
    subtitle: "Reflections on Israel's War Against the Palestinians",
    authors: ["Noam Chomsky", "Ilan Pappé"],
    description: ``,
    released: `2010-01-01`,
    language: "English",
    length: 242,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Politics",
      "History",
      "War",
      "Essays",
      "Political Science",
    ],
    read: [{ start: `2023-10-09`, end: `2023-10-17` }],
    rating: 5,
    review: ``,
    impressions: [`insightful`],
    honour: ``,
    cover: `gaza-in-crisis.jpg`,
  },
  {
    title: "On Palestine",
    subtitle: "",
    authors: ["Noam Chomsky", "Ilan Pappé"],
    description: ``,
    released: `2015-05-07`,
    language: "English",
    length: 168,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Politics",
      "History",
      "War",
      "Essays",
      "Political Science",
    ],
    read: [{ start: `2023-10-19`, end: `2023-10-26` }],
    rating: 5,
    review: ``,
    impressions: [`insightful`],
    honour: ``,
    cover: `on-palestine.jpg`,
  },
  {
    title: "How to Spot a Fascist",
    subtitle: "",
    authors: ["Umberto Eco"],
    description: ``,
    released: `2020-08-13`,
    language: "English",
    length: 58,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Politics",
      "History",
      "Philosophy",
      "Essays",
      "Sociology",
    ],
    read: [{ start: `2023-10-28`, end: `2023-10-28` }],
    rating: 5,
    review: ``,
    impressions: [`insightful`],
    honour: ``,
    cover: `how-to-spot-a-fascist.jpg`,
  },
  {
    title: "Feminism Is for Everybody",
    subtitle: "Passionate Politics",
    authors: ["bell hooks"],
    description: ``,
    released: `2000-10-01`,
    language: "English",
    length: 138,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Politics",
      "Feminism",
      "Social Justice",
      "Gender",
      "Sociology",
      "Philosophy",
      "Race",
    ],
    read: [{ start: `2023-10-31`, end: `2023-11-07` }],
    rating: 5,
    review: ``,
    impressions: [`insightful`],
    honour: ``,
    cover: `feminism-is-for-everybody.jpg`,
  },
  {
    title: "Why Socialism",
    subtitle: "",
    authors: ["Albert Einstein"],
    description: ``,
    released: `1949-05-03`,
    language: "English",
    length: 7,
    medium: "eBook",
    genres: [
      "Non-Fiction",
      "Politics",
      "Theory",
      "Economics",
      "Essays",
      "History",
      "Social Justice",
    ],
    read: [{ start: `2023-11-08`, end: `2023-11-08` }],
    rating: 5,
    review: ``,
    impressions: [`insightful`],
    honour: ``,
    cover: `why-socialism.jpg`,
  },
  {
    title: "1984",
    subtitle: "",
    authors: ["George Orwell"],
    description: ``,
    released: `1949-06-08`,
    language: "English",
    length: 258,
    medium: "eBook",
    genres: ["Fiction", "Classics", "Science Fiction", "Dystopia", "Politics"],
    read: [{ start: `2023-11-10`, end: `2023-12-03` }],
    rating: 4,
    review: ``,
    impressions: [``],
    honour: ``,
    cover: `1984.jpg`,
  },
  {
    title: "Poveste de Crăciun",
    subtitle: "",
    authors: ["Charles Dickens"],
    description: `Publicata pentru prima data in 1843, Poveste de Craciun de Charles Dickens, a devenit un clasic atemporal si una dintre cele mai iubite si reprezentative lecturi din perioada sarbatorilor de iarna.
    Protagonistul, Ebenezer Scrooge, este un batran zgarcit si avar, lipsit de blandete, care nu se gandeste decat la propriile sale interese si nu arata niciun fel de compasiune fata de cei din jur.`,
    released: `1843-12-17`,
    language: "Romanian",
    length: 160,
    medium: "Paperback",
    genres: ["Fiction", "Classics", "Fantasy", "Christmas"],
    read: [{ start: `2023-12-26`, end: `2023-12-30` }],
    rating: 5,
    review: ``,
    impressions: [`Liked`],
    honour: ``,
    cover: `poveste-de-craciun.jpg`,
  },
];
